define([
  'es6!sumo/util',
  'immutable',
  'es6!launcher/actions/DiscountActions',
], (Util, Immutable, Actions) => {
  const initialState = Immutable.Map({
    discounts: Immutable.Map(),
    discountCampaigns: Immutable.List(),
    allCampaigns: Immutable.List(),
    textFilter: '',

    campaignsPage: 1,
    campaignsLimit: 10,
    campaignsTotal: 0,

    discountsPage: 1,
    discountsLimit: 10,
    discountsTotal: 0,
    discountsFilter: ['redeemed', 'issued', 'unissued'],

    loading: true,
    download: Immutable.Map(),

    shopifyAccessToken: null,
    shopifyAccessTokenValid: null,

    currency: Immutable.Map(),

    wooCommerceAccessToken: null,
    wooCommerceAccessTokenValid: null,

    service: 'sumo',

    error: null,
  });

  const actionHandlers = {};

  actionHandlers[Actions.RECEIVE_DISCOUNT_CAMPAIGNS] = (state, action) => {
    const { discountCampaigns } = action;
    return state.set('discountCampaigns', Immutable.fromJS(discountCampaigns));
  };

  actionHandlers[Actions.RECEIVE_DISCOUNTS] = (state, action) => {
    const { campaignId, discounts } = action;
    return state.setIn(['discounts', campaignId], Immutable.fromJS(discounts));
  };

  actionHandlers[Actions.CLEAR_DISCOUNT_CAMPAIGNS] = state => state.merge(Immutable.fromJS({
    discountCampaigns: Immutable.List(),
    allCampaigns: Immutable.List(),
  }));

  actionHandlers[Actions.UPDATE_DISCOUNT_SETTING] = (state, action) => {
    const { setting, value } = action;

    let newState = state;
    if (setting === 'shopifyAccessToken' && value) {
      newState = newState.set('service', 'shopify');
    } else if (setting === 'wooCommerceAccessToken' && value) {
      newState = newState.set('service', 'wooCommerce');
    }

    return newState.setIn([setting], value);
  };

  actionHandlers[Actions.RECEIVE_DISCOUNT_DOWNLOAD_PROGRESS] = (state, action) => (
    state.setIn(['download'], Immutable.fromJS(action.status))
  );

  actionHandlers[Actions.RECEIVE_DISCOUNT_SETTINGS] = (state, action) => {
    const { settings } = action;

    if (settings.shopifyAccessToken) settings.service = 'shopify';
    else if (settings.wooCommerceAccessToken) settings.service = 'woocommerce';
    else settings.service = 'sumo';

    return state.merge(Immutable.fromJS(settings));
  };

  return Util.createReducer(initialState, actionHandlers);
});
